import { render, staticRenderFns } from "./StatisticsAlarm.vue?vue&type=template&id=10fc3d19&scoped=true"
import script from "./StatisticsAlarm.vue?vue&type=script&lang=js"
export * from "./StatisticsAlarm.vue?vue&type=script&lang=js"
import style0 from "./StatisticsAlarm.vue?vue&type=style&index=0&id=10fc3d19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc3d19",
  null
  
)

export default component.exports